import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgPageLeft",
  "use": "icon-svgPageLeft-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-svgPageLeft\">\n<style type=\"text/css\">\n\t#icon-svgPageLeft .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#202820;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M4,27h40v1H4V27z\" />\n\t<path class=\"st0\" d=\"M16,20v2l-9,6l-1-1L16,20z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol